import {
  ToastType,
  dismissChartToast,
  showChartToast
} from "components/charts/components/ChartToast";

const handleTypeWellMissingDataToast = (
  chartId: string,
  numberOfTypeWellsMissingData: number
) => {
  const toastId = `type-well-missing-data-${chartId}`;

  if (numberOfTypeWellsMissingData > 0) {
    const message = `${numberOfTypeWellsMissingData} type well${
      numberOfTypeWellsMissingData > 1 ? "s" : ""
    } without well data for the selected field${
      numberOfTypeWellsMissingData > 1 ? "s were" : " was"
    } removed from the chart.`;

    showChartToast(chartId, message, ToastType.Warning, { toastId });
  } else {
    dismissChartToast(chartId, toastId);
  }
};

export default handleTypeWellMissingDataToast;
